import { render, staticRenderFns } from "./stretching.vue?vue&type=template&id=17c581c4&"
import script from "./stretching.vue?vue&type=script&lang=js&"
export * from "./stretching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports